import type { Dict } from './en';

export const ro: Dict = {
  appTagline: 'Tracker de zboruri live, open-source',
  search: 'Caută zbor, înmatriculare, hex sau aeroport',
  searchNoResults: 'Nimic găsit în zonă sau în rețea.',
  searchUpstream: 'Caut în rețea…',
  filters: 'Filtre',
  layers: 'Hartă',
  settings: 'Setări',
  about: 'Despre și date',
  close: 'Închide',
  aircraft: 'Aeronave',
  inView: 'vizibile',
  ground: 'La sol',
  altitude: 'Altitudine',
  geoAltitude: 'Altitudine GPS',
  speed: 'Viteză la sol',
  vs: 'Viteză verticală',
  track: 'Direcție',
  squawk: 'Squawk',
  registration: 'Înmatriculare',
  type: 'Tip',
  category: 'Categorie',
  hex: 'ICAO 24-bit',
  source: 'Sursa poziției',
  positionAge: 'Vechimea poziției',
  provider: 'Furnizor date',
  route: 'Rută',
  routeUnknown: 'Nu există rută înregistrată pentru acest indicativ.',
  routeImplausible: 'Există o rută înregistrată, dar nu corespunde poziției actuale, așa că e ascunsă.',
  routeNote: 'Ruta obișnuită pentru acest indicativ (date comunitare). Nu e un orar live.',
  follow: 'Urmărește',
  unfollow: 'Oprește urmărirea',
  share: 'Copiază link',
  copied: 'Link copiat',
  trail: 'Traseul arată pozițiile primite de când urmărești.',
  emergency: 'Urgență',
  military: 'Militar',
  noCallsign: 'Fără indicativ',
  zoomIn: 'Mărește harta ca să încarci toată zona. Se afișează doar centrul.',
  stale: 'Date întârziate: rețeaua comunitară limitează cererile sau e indisponibilă. Se afișează ultimele poziții cunoscute.',
  offline: 'Ești offline. Pozițiile revin când se reface conexiunea.',
  loading: 'Se încarcă aeronavele live…',
  errorData: 'API-ul Skywake nu răspunde.',
  apiNotConfigured: 'Această versiune nu are configurat un API de date live, deci nu poate afișa avioane.',
  retry: 'Reîncearcă',
  dataAge: 'Vechimea datelor',
  providerStatus: 'Stare furnizor',
  ok: 'OK',
  degraded: 'Degradat',
  theme: 'Temă',
  themeAuto: 'Sistem',
  themeLight: 'Luminoasă',
  themeDark: 'Întunecată',
  units: 'Unități',
  language: 'Limbă',
  labels: 'Etichete indicativ',
  airports: 'Aeroporturi',
  trails: 'Traseu pentru aeronava selectată',
  colorBy: 'Colorează după',
  colorAlt: 'Altitudine',
  colorSource: 'Sursa poziției',
  altMin: 'Altitudine min. (ft)',
  altMax: 'Altitudine max. (ft)',
  speedMin: 'Viteză min. (kt)',
  speedMax: 'Viteză max. (kt)',
  callsignPrefixes: 'Companie / prefix indicativ',
  callsignPrefixesHint: 'Separate prin virgulă, ex. ROT, WZZ, RYR',
  types: 'Tipuri de aeronave',
  typesHint: 'Coduri ICAO, * ca wildcard, ex. A32*, B738',
  hideGround: 'Ascunde aeronavele de la sol',
  onlyEmergency: 'Doar urgențe (7500/7600/7700)',
  onlyMilitary: 'Doar militare',
  sources: 'Surse de poziție',
  presets: 'Preseturi salvate',
  presetName: 'Nume preset',
  savePreset: 'Salvează filtrele curente',
  apply: 'Aplică',
  delete: 'Șterge',
  clearFilters: 'Resetează filtrele',
  filtered: 'filtrate',
  airport: 'Aeroport',
  elevation: 'Elevație',
  nearbyTraffic: 'Trafic în raza de 30 km',
  noNearby: 'Nicio aeronavă urmărită lângă acest aeroport acum.',
  viewOnOurAirports: 'Vezi pe OurAirports',
  bookmarks: 'Favorite',
  bookmarkView: 'Salvează această vedere',
  watchlist: 'Urmărește',
  watching: 'Urmărită',
  alerts: 'Alerte',
  alertsEmergency: 'Anunță-mă la squawk de urgență în zona vizibilă',
  alertsWatch: 'Anunță-mă când apar aeronavele urmărite',
  alertsPermissionDenied: 'Notificările sunt blocate de browser. Alertele apar doar în aplicație.',
  emergencyAlert: 'Squawk de urgență',
  watchAlert: 'Aeronavă urmărită detectată',
  adsb: 'ADS-B',
  mlat: 'MLAT',
  tisb: 'TIS-B',
  adsr: 'ADS-R',
  modes: 'Mode S',
  other: 'Altele',
  attribution: 'Date aeronave: contribuitorii ADSB.lol (ODbL 1.0). Rute: VRS standing data (CC0). Aeroporturi: OurAirports (domeniu public). Fotografii: fotografii Planespotters.net (creditați la fiecare poză). Vremea: NOAA Aviation Weather Center (domeniu public).',
  aboutBody:
    'Skywake e software gratuit și open-source. Pozițiile vin de la receptoare ADS-B ale voluntarilor, agregate de ADSB.lol, iar acoperirea depinde de unde rulează voluntarii receptoare. Fără conturi, fără reclame, fără cookie-uri de urmărire. Setările rămân pe acest dispozitiv.',
  limitations: 'Limitări cunoscute',
  limitationsList:
    'Încă nu există istoric sau replay: Skywake arată doar ce a primit de când l-ai deschis.|Rutele vin dintr-o bază comunitară de indicative și pot fi greșite sau vechi.|Acoperirea e slabă deasupra oceanelor și în regiuni cu puține receptoare.|Aeronavele ai căror proprietari au cerut confidențialitate (ex. LADD/PIA) pot fi ascunse sau anonimizate la sursă.',
  sourceCode: 'Cod sursă',
  feedData: 'Rulează un receptor și trimite date către ADSB.lol',
  version: 'Versiune',
  webglMissing: 'Browserul tău nu poate desena harta live (WebGL2 indisponibil).',
  selectedOutOfCoverage: 'Această aeronavă nu mai este recepționată.',
  emergencies: 'Urgențe',
  compare: 'Compară',
  list: 'Listă',
  sortBy: 'Sortează după',
  callsign: 'Indicativ',
  locate: 'Locația mea',
  photoAlt: 'Fotografie a aeronavei {reg}',
  weather: 'Vremea (METAR)',
  weatherUnavailable: 'Vremea nu e disponibilă acum.',
  weatherNone: 'Acest aeroport nu publică METAR.',
  weatherSource: 'NOAA Aviation Weather Center. Nu se folosește pentru planificarea zborurilor.',
  wind: 'Vânt',
  calm: 'Calm',
  variable: 'Variabil',
  gusts: 'rafale',
  visibility: 'Vizibilitate',
  temperature: 'Temp. / punct de rouă',
  clouds: 'Nori',
  observed: 'Vechime raport',
  legFlown: 'parcurși',
  legToGo: 'rămași',
  legEta: 'Sosire',
  legNote: 'Estimare pe ortodromă, din ruta obișnuită și viteza curentă.',
};
